import { jsx as _jsx } from "react/jsx-runtime";
import s from './ContentBlock.module.scss';
export const ContentBlock = ({ children, withoutPadding, className }) => _jsx("div", { className: `${s.content_block} ${className || ''}`, style: { padding: withoutPadding ? 0 : '' }, children: children });
